module.exports = __webpack_public_path__ + "img/4.b83bf527.jpg";